<ng-container *ngIf="printLabelData">
  <!-- Outer -->
  <ng-container *ngIf="printLabelData.outerLabels">
    <div class="label-section__title">
      {{ 'LABELS.OUTER_OU' | translate }}
    </div>
    <div class="label-section__table">
      <app-print-label
        [printInfo]="printLabelData.outerLabels"
        [isQuantityPerOuterValidationRequired]="false"
        [productionOrderId]="productionOrderId"
        (quantityChanged)="onQuantityChanged($event)"
      ></app-print-label>
    </div>
  </ng-container>

  <ng-container *ngIf="printLabelData.reelOuterLabels">
    <div class="label-section__title">
      {{ 'LABELS.REEL_OUTER_LABEL' | translate }}
    </div>
    <div class="label-section__table">
      <app-print-label
        [printInfo]="printLabelData.reelOuterLabels"
        [isQuantityPerOuterValidationRequired]="false"
        [productionOrderId]="productionOrderId"
      ></app-print-label>
    </div>
  </ng-container>

  <!-- Tray -->
  <ng-container *ngIf="printLabelData.trayLabels">
    <div class="label-section__title">
      {{ 'LABELS.TRAY_LABEL' | translate }}
    </div>
    <div class="label-section__table">
      <app-print-label
        [printInfo]="printLabelData.trayLabels"
        [isQuantityPerOuterValidationRequired]="true"
        [productionOrderId]="productionOrderId"
      ></app-print-label>
    </div>
  </ng-container>

  <!-- Pack -->
  <ng-container *ngIf="printLabelData.packLabels">
    <div class="label-section__title">
      {{ 'LABELS.PACK_LABEL' | translate }}
    </div>
    <div class="label-section__table">
      <app-print-label
        [printInfo]="printLabelData.packLabels"
        [isQuantityPerOuterValidationRequired]="true"
        [productionOrderId]="productionOrderId"
      ></app-print-label>
    </div>
  </ng-container>

  <!-- Core -->
  <ng-container *ngIf="printLabelData.coreLabels">
    <div class="label-section__title">
      {{ 'LABELS.CORE_LABEL' | translate }}
    </div>
    <div class="label-section__table">
      <app-print-label
        [printInfo]="printLabelData.coreLabels"
        [isQuantityPerOuterValidationRequired]="true"
        [productionOrderId]="productionOrderId"
      ></app-print-label>
    </div>
  </ng-container>
</ng-container>
